import { DateTime } from 'luxon';
import type { Dispatch } from 'redux';

import { updateSellerSettingsBulk } from '../../../pages/settings/api/save-settings';
import { setHasViewedUpsInvoicedModal } from '../../../store/seller/seller.actions';
import { SellerSettings } from '../../../enums/seller-settings/seller-settings';

type UpsInvoicedInteractionPayload = {
  acceptedAtUtc: string;
  userId?: string | number;
  sellerLabelProviderId?: string | number;
};

export const recordUpsInvoicedInteraction = async (payload: UpsInvoicedInteractionPayload, dispatch: Dispatch): Promise<void> => {
  await updateSellerSettingsBulk({ [SellerSettings.hasViewedUpsInvoicedModal.key]: JSON.stringify(payload) });
  dispatch(setHasViewedUpsInvoicedModal(true));
};

export const buildInteractionPayload = (userId?: string | number): UpsInvoicedInteractionPayload => ({
  acceptedAtUtc: DateTime.now().toUTC().toString(),
  userId,
});
